import { MainProps } from '@/components/landing-page/components/main/main.types';
import { defaults as successBoxDefaults } from '@/components/landing-page/components/success-box';

export const defaults: Required<MainProps> = {
  successBox: successBoxDefaults,
  groups: [],
};
